import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './P1InvalidPatientDataMessage.module.scss';

const P1InvalidPatientDataMessage: React.FC = () => {
	return (
		<Text
			className={styles.invalidPatientText}
			tx='component.electronicPrescriptionPoland.invalidPatientData'
		/>
	);
};

export default P1InvalidPatientDataMessage;
